import { render, staticRenderFns } from "./LaborDataIndependent.vue?vue&type=template&id=5eabac88&scoped=true&"
import script from "./LaborDataIndependent.vue?vue&type=script&lang=ts&"
export * from "./LaborDataIndependent.vue?vue&type=script&lang=ts&"
import style0 from "./LaborDataIndependent.vue?vue&type=style&index=0&id=5eabac88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eabac88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
